/* ApplyTheme — drop this component anywhere in a page's JSX to declare:
 *   "While this page is mounted, the active theme is X (the user we're
 *   viewing). When it unmounts, clear the active theme."
 *
 * Usage:
 *   <ApplyTheme theme={user.theme} ownerLabel={`@${user.username}`} source="profile" />
 *
 * The actual painting is done by <ThemeStage/> which lives at the top of
 * the app tree (App.js) — it watches `active` from context and renders:
 *   1. <body data-vault-bg="...">  via a useEffect
 *   2. The floating audio player (ThemePlayer)
 *   3. The optional marquee strip
 */
import { useEffect } from "react";
import { useVaultTheme } from "./VaultThemeProvider";

export default function ApplyTheme({ theme, ownerLabel, source = "page" }) {
  const { setActiveTheme } = useVaultTheme();
  useEffect(() => {
    if (!theme) return;
    setActiveTheme({ theme, ownerLabel: ownerLabel || "", source });
    return () => setActiveTheme(null);
  }, [theme, ownerLabel, source, setActiveTheme]);
  return null;
}
